import clsx from "clsx";
import { useEffect, useState } from "react";
import AlertPlayer from "ui/alerts/alert-player";
import {
  SvgMapMarker,
  SvgCalendar,
  SvgAlertShareAlert,
  SvgAlertDownload,
  SvgLogo,
  SvgPlayback,
  SvgGotoAlert,
  SvgConvertToCase,
  SvgCopy,
  SvgMergeAlertToCase,
} from "ui/svgs";
import moment from "moment";
import { getAlertIcon } from "ui/components/common";
import {
  softTitle,
  getEventText,
  downloadVideoUrl,
  copyToClipBoard,
} from "lib/utils";
import ShareAlertModal from "ui/alerts/share-alert-modal";
import { useService } from "pages/dashboard/alerts/service";
import { Tooltip } from "antd";
import PlaybackModal from "ui/playback/playback-modal";
import { Popover as PopoverAntd, Image } from "antd";
import { useNavigate } from "react-router-dom";
import CaseTypeModal from "./caseTypeModal";
import { ALERT_PROCESS_STATUS_SDK } from "lib/constants";
import AlertMergeCaseModal from "ui/dealer-focus/alert-merge-case-modal";
export default function Page({ activeAlert, onAlertStatusChange, activeCase }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [snapShotSrc, setSnapShotSrc] = useState(null);
  const { getSnapShotByAlertObj } = useService();
  const [playbackModalVisible, setPlaybackModalVisible] = useState(false);
  const [caseTypeModalVisible, setCaseTypeModalVisible] = useState(false);
  const navigate = useNavigate();
  const [mergeModalOpen, setMergeModalOpen] = useState(false);
  useEffect(() => {
    if (!activeAlert) {
      return;
    }
    if (
      activeAlert?.snapshot?.location === "local" ||
      !activeAlert?.video?.url
    ) {
      setSnapShotSrc(null);
      getSnapShotByAlertObj(activeAlert)
        .then((data) => {
          setSnapShotSrc(URL.createObjectURL(data));
        })
        .catch((e) => console.error(e));
    }
  }, [activeAlert]);

  const handleShareAlert = () => {
    setIsModalOpen(true);
  };
  function downloadPic() {
    const link = document.createElement("a");
    link.href = snapShotSrc;
    link.download = "alert_pic.jpg"; // You can set the default file name here
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  function handleGotoAlert(e) {
    e.stopPropagation();
    navigate(
      `/dashboard/alerts?startedAt=${activeAlert.startedAt}&endedAt=${activeAlert.endedAt}&id=${activeAlert.id}`,
    );
  }
  function convertToCase() {
    setCaseTypeModalVisible(true);
  }
  const formatContextDate = (
    dateTime: Date | string | number,
    options?: Intl.DateTimeFormatOptions,
  ) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (!options) {
      options = {
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
    }
    const date = new Date(dateTime);
    const refDate = new Date(dateTime);
    refDate.setHours(0, 0, 0, 0);

    return date.toLocaleDateString("en-US", {
      ...(options as Intl.DateTimeFormatOptions),
      // weekday: "short",
    });
  };
  return (
    <div
      className="flex flex-col justify-center w-full "
      style={{
        borderBottom: "1px solid rgba(225, 225, 225, 1)",
        padding: "0px 1rem 1rem 1rem",
      }}
    >
      {activeAlert?.snapshot?.location !== "local" &&
      activeAlert?.video?.url ? (
        <>
          <div
            className="flex-grow md:overflow-y-hidden flex items-center bg-black w-full aspect-video"
            style={{ borderRadius: "16px", overflow: "hidden" }}
          >
            <AlertPlayer videoUrl={activeAlert?.video?.url} />
          </div>
        </>
      ) : (
        <div
          className="relative w-full bg-zinc-100 h-full  aspect-video"
          style={{ borderRadius: "16px", overflow: "hidden" }}
        >
          {snapShotSrc ? (
            <Image
              src={snapShotSrc}
              alt="Camera Snapshot"
              className="aspect-video"
              width="100%"
              height="100%"
              //preview={{ mask: <></> }}
            />
          ) : (
            <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center">
              <SvgLogo width="60" className="fill-neutral-400 mb-3" />
              <p className="text-neutral-400 font-semibold text-2xl">
                {softTitle()}
              </p>
            </div>
          )}
        </div>
      )}

      {/* Control bar */}
      <div style={{ display: "flex" }}>
        <div
          className="flex py-2  gap-1 text-neutral-800"
          style={{ flex: "1" }}
        >
          {activeAlert?.eventTypes?.length > 0 && (
            <div
              className="flex items-center justify-center rounded-xl text-sm "
              style={{ flex: "none", overflow: "hidden" }}
            >
              {getAlertIcon(activeAlert?.eventTypes[0], true)}
              <PopoverAntd
                content={`The following event detected: ${activeAlert?.eventTypes.join(",")}`}
                title=""
              >
                <p
                  className="text-sm font-semibold text-left p-1"
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {getEventText(activeAlert?.eventTypes[0])}
                </p>
              </PopoverAntd>
            </div>
          )}
          <div
            className="flex  items-center text-neutral-800 text-sm"
            style={{ flex: "1", overflow: "hidden" }}
          >
            <SvgCalendar width="18" className="fill-zinc-500" />
            <p className="text-sm text-left p-1">
              {formatContextDate(new Date(Number(activeAlert?.createdAt))) ||
                "-"}
            </p>
          </div>
        </div>
        <div
          className=" flex items-center justify-between"
          style={{ flex: "none", justifyContent: "end" }}
        >
          {/* using event type as flag, additionals to the right of control bar e.g. Share */}
          {activeAlert?.eventTypes?.length && (
            <div
              className={clsx("flex justify-center")}
              style={{ padding: "6px 0px" }}
            >
              <button
                onClick={() => setPlaybackModalVisible(true)}
                className="w-[40px] h-[30px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:fill-neutral-400 disabled:bg-transparent disabled:cursor-not-allowed"
              >
                <SvgPlayback width="25" />
              </button>
              <button
                onClick={handleShareAlert}
                className="w-[40px] h-[30px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:fill-neutral-400 disabled:bg-transparent disabled:cursor-not-allowed"
              >
                <SvgAlertShareAlert width="20" />
              </button>

              <button
                disabled={!activeAlert?.video?.url && !snapShotSrc}
                onClick={() => {
                  if (activeAlert?.video?.url) {
                    downloadVideoUrl(
                      activeAlert?.video?.url,
                      activeAlert?.camera?.name +
                        "_" +
                        moment(+activeAlert.createdAt).format(
                          "YYYY-MM-DD_HH_mm_ss",
                        ),
                    );
                  } else {
                    downloadPic();
                  }
                }}
                className="w-[40px] h-[30px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:fill-neutral-400 disabled:bg-transparent disabled:cursor-not-allowed"
              >
                <SvgAlertDownload width="20" />
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="flex-grow flex space-between">
        <div
          className="flex-grow flex items-center fill-zinc-500 gap-4 text-neutral-800"
          style={{ overflow: "hidden" }}
        >
          <div className="flex gap-1">
            <SvgMapMarker width="16" className="flex-shrink-0" />
            <Tooltip title={activeAlert?.site?.name}>
              <p className="max-w-48 overflow-hidden break-words text-ellipsis text-nowrap break-all">
                {activeAlert?.site?.name}
              </p>
            </Tooltip>
          </div>
        </div>
        <Tooltip
          title={
            activeAlert?.status !== ALERT_PROCESS_STATUS_SDK.Investigate &&
            "Merge"
          }
        >
          <button
            className="w-[40px] h-[30px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:opacity-25 disabled:fill-neutral-400"
            disabled={activeCase}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setMergeModalOpen(true);
            }}
          >
            <SvgMergeAlertToCase width="20" />
          </button>
        </Tooltip>
        <Tooltip title={"Convert to case"}>
          <button
            disabled={activeCase}
            onClick={convertToCase}
            className="w-[40px] h-[30px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent  disabled:fill-neutral-400 disabled:opacity-25 disabled:bg-transparent disabled:cursor-not-allowed"
          >
            <SvgConvertToCase />
          </button>
        </Tooltip>
        <Tooltip title={"Go to alert"}>
          <button
            onClick={handleGotoAlert}
            className="w-[40px] h-[30px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:fill-neutral-400 disabled:bg-transparent disabled:cursor-not-allowed"
          >
            <SvgGotoAlert />
          </button>
        </Tooltip>
      </div>
      <ShareAlertModal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        alertId={activeAlert?.id}
      />
      <PlaybackModal
        orgId={activeAlert?.orgId}
        visible={playbackModalVisible}
        onClose={() => setPlaybackModalVisible(false)}
        cameraId={activeAlert?.camera?.id}
        //alertTime={+activeAlert?.createdAt}
        startAt={+activeAlert?.createdAt - 1000 * 60 * 10}
        endAt={+activeAlert?.createdAt + 1000 * 60 * 5}
        initialSeekAt={+activeAlert?.createdAt}
        alertId={activeAlert?.id}
      />
      <CaseTypeModal
        visible={caseTypeModalVisible}
        onClose={() => setCaseTypeModalVisible(false)}
        onAlertStatusChange={onAlertStatusChange}
        activeAlert={activeAlert}
      />
      <AlertMergeCaseModal
        isModalOpen={mergeModalOpen}
        setIsModalOpen={setMergeModalOpen}
        alertId={activeAlert?.id}
        onMerged={onAlertStatusChange}
      />
    </div>
  );
}
